<pagination [listId]="listId"></pagination>
<div class="items">
  <pages-list-item [page]="page" *ngFor="let page of pages"></pages-list-item>
</div>
<pagination [listId]="listId"></pagination>

